<ng-container [formGroup]="inputForm">
  <ng-container [formGroupName]="customFormName">
    <div class="row">
      <div class="col-xs-12 col-md-8 mb-3">
        <label for="postcodeSearch" class="form-label"><sup>* </sup>Postcode</label>
        <div class="input-group postcode-search">
          <input type="text"
                 [formControlName]="customPostcodeName"
                 class="form-control form-control-lg col-xs-12 col-md-6"
                 id="postcodeSearch"
                 placeholder="E.g. SW8 3TP"
                 [value]="postcode?.value"
                 (keyup.enter)="getPostcode()"
                 yp-e2e-id="postcode-lookup-postcode-find-input">
          <button class="button button-white w-50"
                  type="button"
                  [appButtonLoader]="isLoading"
                  (click)="getPostcode()"
                  yp-e2e-id="postcode-lookup-postcode-find-button">Find address
          </button>
        </div>
      </div>
      <div class="col-xs-12 col-md-3 mb-3 mb-md-auto mt-auto ml-4">
        <button
          class="button-text pb-1 border-bottom border-dark"
          type="button"
          (click)="manualPostcodeInput=true"
          yp-e2e-id="postcode-lookup-manual-input-switch">Add address manually
        </button>
      </div>
    </div>

    <div class="alert-container mb-3" *ngIf="postcode?.errors && (formSubmitted || clickedFindAddress)">
      <div class="alert alert-danger mt-0"
           yp-e2e-id="postcode-lookup-postcode-find-invalid-alert"
           *ngIf="postcode?.errors?.required">{{FIELD_MANDATORY_ERROR}}
      </div>
      <div class="alert alert-danger mt-0"
           yp-e2e-id="postcode-lookup-postcode-find-invalid-alert"
           *ngIf="postcode?.errors?.pattern || postcode?.errors?.hasNoLengthWithoutWhitespaces">{{VALID_POSTCODE_ERROR}}
      </div>
      <div class="alert alert-danger mt-0"
           yp-e2e-id="postcode-lookup-postcode-find-invalid-alert"
           *ngIf="postcode?.errors?.maxlength">{{SHORTER_POSTCODE_ERROR}}
      </div>
    </div>

    <div class="row" *ngIf="showAddressListSelect">
      <div class="col-md-9 mb-3">
        <select class="form-select form-control"
                formControlName="selectedAddressId"
                yp-e2e-id="postcode-lookup-address-select"
                (change)="selectedAddress()">
          <option [value]="''" disabled>Please select your address</option>
          <option *ngFor="let address of addressListForToDisplay"
                  yp-e2e-id="postcode-lookup-address-select-option"
                  [value]="address.id">{{address.label}}</option>
        </select>
      </div>
    </div>

    <div class="alert-container mb-3"
         *ngIf="showAddressListSelectValidationError">
      <div class="alert alert-danger mt-0"
           yp-e2e-id="postcode-lookup-alert">
        {{SELECT_ADDRESS_FILL_MANUALLY_ERROR}}
      </div>
    </div>

    <ng-container *ngIf="manualPostcodeInput">
      <div class="row">
        <div class="col-md-6 mb-3">
          <label for="houseNameNumber" class="form-label"><sup>* </sup>House name or number</label>
          <input type="email"
                 [formControlName]="customHouseNameNumberName"
                 class="form-control form-control"
                 id="houseNameNumber"
                 yp-e2e-id="postcode-lookup-property-name-input">
          <div class="alert-container" *ngIf="houseNameNumber?.errors && formSubmitted">
            <div class="alert alert-danger"
                 yp-e2e-id="postcode-lookup-property-name-alert"
                 *ngIf="houseNameNumber?.errors?.required || houseNameNumber?.errors?.hasNoLengthWithoutWhitespaces">{{FIELD_MANDATORY_ERROR}}
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <label for="address1" class="form-label"><sup>* </sup>Street</label>
          <input type="text"
                 [formControlName]="this.customAddressName"
                 class="form-control form-control"
                 id="address1"
                 yp-e2e-id="postcode-lookup-street-input">
          <div class="alert-container" *ngIf="address1?.errors && formSubmitted">
            <div class="alert alert-danger"
                 yp-e2e-id="postcode-lookup-street-alert"
                 *ngIf="address1?.errors?.required || address1?.errors?.hasNoLengthWithoutWhitespaces">{{FIELD_MANDATORY_ERROR}}
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 mb-3">
          <label for="town" class="form-label"><sup>* </sup>Town or city</label>
          <input type="text"
                 [formControlName]="this.customTownName"
                 class="form-control form-control-lg"
                 id="town"
                 yp-e2e-id="postcode-lookup-town-input">
          <div class="alert-container" *ngIf="town?.errors && formSubmitted">
            <div class="alert alert-danger"
                 yp-e2e-id="postcode-lookup-town-alert"
                 *ngIf="town?.errors?.required || town?.errors?.hasNoLengthWithoutWhitespaces">{{FIELD_MANDATORY_ERROR}}
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <label for="postcode" class="form-label"><sup>* </sup>Postcode</label>
          <input type="text"
                 [formControlName]="this.customPostcodeName"
                 class="form-control form-control-lg"
                 id="postcode"
                 [value]="postcode.value"
                 yp-e2e-id="postcode-lookup-postcode-input">
          <div class="alert-container" *ngIf="postcode?.errors && formSubmitted">
            <div class="alert alert-danger"
                 yp-e2e-id="postcode-lookup-postcode-alert"
                 *ngIf="postcode?.errors?.required">{{FIELD_MANDATORY_ERROR}}
            </div>
            <div class="alert alert-danger"
                 yp-e2e-id="postcode-lookup-postcode-alert"
                 *ngIf="postcode?.errors?.pattern || postcode?.errors?.hasNoLengthWithoutWhitespaces">{{VALID_POSTCODE_ERROR}}
            </div>
            <div class="alert alert-danger"
                 yp-e2e-id="postcode-lookup-postcode-alert"
                 *ngIf="postcode?.errors?.maxlength">{{SHORTER_POSTCODE_ERROR}}
            </div>
          </div>
        </div>
      </div>
    </ng-container>

  </ng-container>
</ng-container>
